"use client";
import { Card } from "@nextui-org/react";

const ImageAnimationsSkeleton = () => {
  // Create skeleton cards array to match original structure
  const skeletonCards = Array.from({ length: 8 }, (_, index) => (
    <Card
      key={index}
      radius="lg"
      className="!w-[110px] sm:!w-[140px] md:!w-[160px] lg:!w-[220px] border-none h-[160px] sm:h-[200px] md:h-[240px] lg:h-[300px] mx-4"
    >
      <div className="w-full h-full bg-gradient-to-br from-zinc-700 to-zinc-800 animate-pulse" />
    </Card>
  ));

  return (
    <>
      <div className="rotate-23 translate-x-1/4 flex-col opacity-70 w-fit">
        {/* First row skeleton */}
        <div className="flex mb-6 -translate-x-1/4">
          {skeletonCards}
        </div>

        {/* Second row skeleton */}
        <div className="flex mb-6 -translate-x-1/4">
          {skeletonCards}
        </div>

        {/* Third row skeleton */}
        <div className="flex -translate-x-1/4">
          {skeletonCards}
        </div>
      </div>

      {/* Lottie animation skeleton */}
      <div className="absolute w-screen top-0 left-0 right-0 bottom-0 z-10">
        <div className="flex items-center w-full h-full justify-end pl-8 md:pl-16 lg:pl-24 xl:pl-32 2xl:pl-40">
          <div className="h-[95px] md:h-[145px] lg:h-[200px] xl:h-[240px] 2xl:h-[280px] w-[125px] md:w-[205px] bg-zinc-600 animate-pulse rounded-lg" />
        </div>
      </div>
    </>
  );
};

export default ImageAnimationsSkeleton;